import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useSocialMediaLinks } from '../../../hooks';
import linkedin from '../../../assets/social-media/linkedin.png';
import whatsapp from '../../../assets/social-media/whatsapp.png';

const styles = {
  footerContainer: {
    bottom: 0,
    position: 'relative',
    height: '27rem',
    width: '100%',
    display: 'table',
    backgroundColor: '#F8F8F8',
    color: 'text.primary',
    padding: '4rem',
  },
  footerTitle: {},
  spacingGrid: {
    minHeight: '3.9rem',
    justifyContent: 'space-evenly',
  },
  href: {
    color: '#323232',
    textDecoration: 'none',
  },
  logo: {
    width: 130,
  },
  socialMedia: {
    width: 20,
    marginTop: '21%',
  },
};

function SocialMediaStack() {
  const { linkedinLink, whatsappLink } = useSocialMediaLinks();
  const theme = useTheme();
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: '0.625rem',
      }}
    >
      <Typography variant="small_3" color={theme.palette.neutral.A400} fontWeight={700}>¡Síguenos!</Typography>
      <Stack direction="row" spacing={1}>
        <a href={linkedinLink} rel="noopener noreferrer" target="_blank">
          <CardMedia
            component="img"
            image={linkedin}
            alt="logo"
            style={styles.socialMedia}
          />
        </a>
        <a href={whatsappLink} rel="noopener noreferrer" target="_blank">
          <CardMedia
            component="img"
            image={whatsapp}
            alt="logo"
            style={styles.socialMedia}
          />
        </a>
      </Stack>
    </Stack>
  );
}

export default SocialMediaStack;
